/**
 * Removes empty or whitespace-only <p> elements inside .rte containers on pages with /blogs/ in the URL to fix layout gap bugs caused by this elements.
 */
(function () {
  if (window.location.pathname.includes('/blogs/')) {
    document.querySelectorAll('.rte p').forEach((paragraph) => {
      if (!paragraph.textContent.trim() && paragraph.children.length === 0) {
        paragraph.remove();
      }
    });
  }
})();

/**
 * Dynamically adjusts product links and other relevant links within blog article pages to match the current localization and domain.
 */
(function () {
  if (window.location.pathname.includes('/blogs/')) {
    document.addEventListener('DOMContentLoaded', () => {
      const article = document.querySelector('.article');

      if (!article) return;

      const currentURL = new URL(window.location.href);
      const currentPathParts = currentURL.pathname.split('/');

      const localization = currentPathParts.length > 1 && currentPathParts[1].includes('-') ? currentPathParts[1] : '';

      const allLinks = article.querySelectorAll('a');

      allLinks.forEach((link) => {
        const href = link.getAttribute('href');

        if (href.includes('hultafors')) {
          try {
            const linkURL = new URL(href, window.location.origin);

            if (linkURL.host.includes('hultafors') && linkURL.host !== currentURL.host) {
              linkURL.host = currentURL.host;
            }

            const linkPathParts = linkURL.pathname.split('/');

            if (linkPathParts.length > 1 && linkPathParts[1].includes('-')) {
              linkPathParts[1] = localization || linkPathParts[1];
            } else if (localization) {
              linkPathParts.splice(1, 0, localization);
            }

            linkURL.pathname = linkPathParts.join('/');
            link.setAttribute('href', linkURL.toString());
          } catch (error) {
            console.error('Error processing link:', href, error);
          }
        }
      });
    });
  }
})();
